import { DatePicker } from "antd"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import React, { useEffect, useState } from "react"
import secureLocalStorage from "react-secure-storage"
import Select from "react-select"
import Swal from "sweetalert2"
import { FetchPostData } from "utils/common-fetchData"
import { daysOption, ResourceType } from "utils/common-options"

const MaintenanceProjectOverview = ({ projectDetails, onUpdate }) => {
  const sprintOption = [
    {
      value: "weekly",
      label: "Weekly Sprint",
    },
    {
      value: "biweekly",
      label: "Bi-weekly Sprint",
    },
    {
      value: "month",
      label: "Once in a Month",
    },
  ]
  const calculatePercentage = (hours, totalHours) => {
    return totalHours > 0
      ? Math.floor((Number(hours) / Number(totalHours)) * 100)
      : 0
  }
  const [sprintType, setSprintType] = useState([])
  const [sprint, setSprint] = useState([])
  const [sprintDate, setSprintDate] = useState("")
  const [isLoading, setLoading] = useState(false)
  const [hours, setHours] = useState([])
  const [scopeHrs, setScopeHrs] = useState(false)
  const toggleLoading = loading => {
    setLoading(loading)
  }
  useEffect(() => {
    setSprintType(
      sprintOption?.find(obj => obj?.value == projectDetails?.sprint_type)
    )
    if (sprintType?.value == "month") {
      setSprint(projectDetails?.sprint)
    } else {
      setSprint(daysOption?.find(obj => obj?.value == projectDetails?.sprint))
    }
    setHours(projectDetails?.scope_hrs?.split(",") || [])
  }, [projectDetails])
  const token = secureLocalStorage.getItem("auth_token")
  const onSetSprint = async e => {
    e.preventDefault()
    const formEntries = {
      project_id: projectDetails?.id,
      sprint: sprintType?.value == "month" ? sprint : sprint?.value || "",
      sprint_type: sprintType?.value || "",
    }
    const res = await FetchPostData(
      toggleLoading,
      "updateProjectSprint",
      token,
      formEntries
    )
    if (res?.data?.success) {
      Swal.fire({
        icon: "success",
        text: "Sprint Details Updated Successfully",
      }).then(() => {
        onUpdate(true)
      })
    }
  }
  const scopeTotal =
    Number(projectDetails?.designing) +
    Number(projectDetails?.development) +
    Number(projectDetails?.testing)


  const OnAddScopeHours = async e => {
    e.preventDefault()
    const formEntries = {
      project_id: projectDetails?.id,
      status: hours?.map(hour => hour).join(","),
      type: 5,
    }
    const response = await FetchPostData(
      toggleLoading,
      "updateFreezeStatus",
      secureLocalStorage?.getItem("auth_token"),
      formEntries
    )
    if (response?.data?.success) {
      Swal.fire({
        icon: "success",
        text: "Scope Hours Updated Successfully",
      }).then(() => {
        onUpdate(true)
      })
    }
  }
  console.log(`projectDetails`, projectDetails)

  const developmentProjectType = [
    { label: "Regular Project", value: 1 },
    { label: "Dedicated Resource", value: 2 },
    { label: "Maintenance Project", value: 3 },
  ]

  return (
    <div>
      {isLoading && <Loader />}
      <div className="row">
        <div
          className={
            projectDetails?.project_type == 3 ? "col-lg-13" : "col-lg-8"
          }
        >
          <div className="card">
            <div className="card-body">
              <div className="d-flex">
                <div className="flex-grow-1 overflow-hidden">
                  <h5 className="text-purple fw-bold font-size-18">
                    {projectDetails?.project_name}
                  </h5>
                  <p>
                    <strong>Project Type</strong> :{" "}
                    {
                      developmentProjectType.find(
                        obj => obj.value === projectDetails?.project_type
                      )?.label
                    }
                    , <strong>Customer</strong> :{projectDetails?.customerName}
                  </p>
                </div>
              </div>
              <h5 className="font-size-15 mt-4">Project Description :</h5>
              <p
                className="text-muted"
                dangerouslySetInnerHTML={{
                  __html: projectDetails?.description,
                }}
              />
              <div className="d-flex gap-4 mt-5 ">
                <div className="text-muted  ">
                  <p>
                    <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                    <span className="text-purple fw-bold">Project Belongs</span>{" "}
                    :{" "}
                    {projectDetails?.projectbelogsto === 1
                      ? "India"
                      : projectDetails?.projectbelogsto === 2
                        ? "United Kingdom"
                        : projectDetails?.projectbelogsto === 3
                          ? "United States"
                          : "Unknown"}
                  </p>
                  <p>
                    <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                    <span className="text-purple fw-bold">Resource Type</span>:{" "}
                    {ResourceType?.find(
                      obj => obj?.value == projectDetails?.billingtype
                    )?.label || "NULL"}
                  </p>
                  <p className="mb-0">
                    <i className="mdi mdi-chevron-right text-primary me-1"></i>
                    <span className="text-purple fw-bold">
                      Project Industry
                    </span>
                    : {projectDetails?.projectIndustryName}
                  </p>
                </div>
                <div className="info_box_1"></div>
                <div className="text-muted ">
                  <p>
                    <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                    <span className="text-purple fw-bold">
                      Key Account Manager
                    </span>{" "}
                    : {projectDetails?.keyaccountManagerName || "-"}
                  </p>
                  <p>
                    <i className="mdi mdi-chevron-right text-primary me-1"></i>{" "}
                    <span className="text-purple fw-bold">Scrum Master</span>:
                    {projectDetails?.scrumMasterName || "-"}
                  </p>
                </div>
              </div>

              <div className="task-dates row mt-4">
                <div className="col-3 col-sm-3">
                  <div className="mt-4">
                    <h5 className="font-size-14">
                      <i className="bx bx-calendar me-1 text-primary"></i> Start
                      Date
                    </h5>
                    <p className="text-muted mb-0">
                      {moment(projectDetails?.startdate).format("DD MMM, YYYY")}
                    </p>
                  </div>
                </div>
                <div className="col-3 col-sm-3">
                  <div className="mt-4">
                    <h5 className="font-size-14">
                      <i className="bx bx-calendar-check me-1 text-primary"></i>{" "}
                      Est. End Date
                    </h5>
                    <p className="text-muted mb-0">
                      {" "}
                      {moment(projectDetails?.enddate).format("DD MMM, YYYY") ||
                        "-"}
                    </p>
                  </div>
                </div>
              </div>
              {secureLocalStorage.getItem("auth_role") == 9 ||
                secureLocalStorage.getItem("auth_role") == 10 ||
                secureLocalStorage.getItem("auth_role") == 22 ||
                secureLocalStorage.getItem("auth_role") == 4 ||
                secureLocalStorage.getItem("auth_role") == 11 ||
                secureLocalStorage.getItem("auth_role") == 1 ||
                secureLocalStorage.getItem("auth_role") == 18 ? (
                <>
                  <p className="mt-4 pt-3 mb-0">
                    <span className="text-purple fw-bold">
                      Payment Schedule
                    </span>
                  </p>
                  <div className="task-dates row ">
                    <div className="task-dates row">
                      {projectDetails?.payment_schedule?.[0]
                        ?.split("@#")
                        .map((obj, i) => {
                          const dates =
                            projectDetails?.completion_dates?.split("@#")[i]

                          return (
                            <div className="col-3 col-sm-3" key={i}>
                              <div className="mt-3">
                                <h5 className="font-size-14">
                                  <i className="bx bx-calendar me-1 text-primary"></i>{" "}
                                  {obj}
                                </h5>
                                <p className="text-muted mb-0">
                                  {dates
                                    ? moment(dates).format("DD MMM, YYYY")
                                    : "No Date"}
                                </p>
                              </div>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
          <div className="card">
            <div className="card-body ">
              <div className="responsive-table">
                <form className="mb-4" onSubmit={OnAddScopeHours}>
                  <div className="d-flex justify-content-between">
                    <h5 className="mb-3">Allocate Scope</h5>
                  </div>
                  <label htmlFor="">
                    Scopes <span className="text-danger">*</span>
                  </label>
                  {projectDetails?.project_scope?.[0]
                    ?.split(/@#\s*/g) // splits at '@#' and removes any trailing space/newline
                    ?.filter(obj => obj.trim() !== "") // removes empty lines
                    ?.map((obj, i) => (
                      <div className="row align-items-center mt-2" key={i}>
                        <div className="col-md-10">
                          <i className="mdi mdi-chevron-right text-primary me-1"></i>
                          <span className="mb-0 text-purple fs-6">
                            {obj?.trim()}
                          </span>
                        </div>
                      </div>
                    ))}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MaintenanceProjectOverview